import React from "react";
import {
  CardContent,
  IconButton,
  InputAdornment,
  MenuItem,
  Stack,
  TextField,
  Tooltip,
} from "@mui/material";
import Grid2 from "@mui/material/Grid2";

import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import FilterAltOffIcon from "@mui/icons-material/FilterAltOff";
import SearchIcon from "@mui/icons-material/Search";
import DownloadIcon from "@mui/icons-material/Download";

import { StyledCard } from "../styles";

const ActivityLogFilters = ({
  filters,
  setFilters,
  allUsers,
  onApply,
  onClear,
  onExportCsv,
  loading,
}) => {
  return (
    <StyledCard elevation={0}>
      <CardContent>
        <Grid2 container spacing={2}>
          <Grid2 size={{ xs: 12, md: 4 }}>
            <TextField
              select
              fullWidth
              label="Provider / User ID"
              value={filters.user_id}
              onChange={(e) =>
                setFilters((prev) => ({
                  ...prev,
                  user_id: e.target.value,
                }))
              }
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <PersonOutlineIcon fontSize="small" />
                  </InputAdornment>
                ),
              }}
            >
              <MenuItem value="">All Providers</MenuItem>
              {allUsers.map((user) => (
                <MenuItem key={user.user_id} value={user.user_id}>
                  {user.user_name} ({user.user_id})
                </MenuItem>
              ))}
            </TextField>
          </Grid2>

          <Grid2 size={{ xs: 12, sm: 6, md: 3 }}>
            <TextField
              fullWidth
              type="date"
              label="Start Date"
              InputLabelProps={{ shrink: true }}
              value={filters.start_date}
              onChange={(e) =>
                setFilters((prev) => ({
                  ...prev,
                  start_date: e.target.value,
                }))
              }
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <CalendarMonthIcon fontSize="small" />
                  </InputAdornment>
                ),
              }}
            />
          </Grid2>

          <Grid2 size={{ xs: 12, sm: 6, md: 3 }}>
            <TextField
              fullWidth
              type="date"
              label="End Date"
              InputLabelProps={{ shrink: true }}
              value={filters.end_date}
              onChange={(e) =>
                setFilters((prev) => ({
                  ...prev,
                  end_date: e.target.value,
                }))
              }
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <CalendarMonthIcon fontSize="small" />
                  </InputAdornment>
                ),
              }}
            />
          </Grid2>

          <Grid2 size={{ xs: 12, md: 2 }}>
            <Stack direction="row" spacing={1} height="100%">
              <Tooltip title="Apply Filters">
                <span>
                  <IconButton
                    color="primary"
                    onClick={onApply}
                    disabled={loading}
                  >
                    <SearchIcon />
                  </IconButton>
                </span>
              </Tooltip>
              <Tooltip title="Clear Filters">
                <span>
                  <IconButton onClick={onClear} disabled={loading}>
                    <FilterAltOffIcon />
                  </IconButton>
                </span>
              </Tooltip>

              <Tooltip title="Export CSV">
                <span>
                  <IconButton onClick={onExportCsv} disabled={loading}>
                    <DownloadIcon />
                  </IconButton>
                </span>
              </Tooltip>
            </Stack>
          </Grid2>
        </Grid2>
      </CardContent>
    </StyledCard>
  );
};

export default ActivityLogFilters;
